import { QtmButton, QtmDropdownSelect, QtmDropdownSelectOption, QtmIcon } from '@qtm/react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { UserTableModel, availablePageSizes } from 'modules/Users/DataTableDef';
import { setPageIndex, setPageSize } from 'shared/reducers/usersTableSlice';

type Props = {
  users: UserTableModel[];
};

const DataTableFooter = ({ users }: Props) => {
  const dispatch = useAppDispatch();
  const pageSize = useAppSelector(state => state.usersTable.pageSize);
  const pageIndex = useAppSelector(state => state.usersTable.pageIndex);

  const nbPages = Math.ceil(users.length / pageSize);

  const onFirstPage = () => {
    dispatch(setPageIndex(0));
  };

  const onLastPage = () => {
    dispatch(setPageIndex(nbPages - 1));
  };

  const onNextPage = () => {
    dispatch(setPageIndex(pageIndex + 1));
  };

  const onPreviousPage = () => {
    dispatch(setPageIndex(pageIndex - 1));
  };

  const onPageSizeChange = (e: any) => {
    dispatch(setPageIndex(0));
    dispatch(setPageSize(e.target.value));
  };

  return (
    <div className="table-footer">
      <div className="start">
        <div className="actions">
          <div>Items per page:</div>
          <QtmDropdownSelect
            nbVisibleOptions={1}
            size="medium"
            value={pageSize + ''}
            onValueChanged={onPageSizeChange}
            placement="top"
            className="page-size-selector"
          >
            {availablePageSizes.map(size => (
              <QtmDropdownSelectOption key={size} value={size + ''}>
                {size}
              </QtmDropdownSelectOption>
            ))}
          </QtmDropdownSelect>
        </div>
        <div className="info">{users.length} items</div>
      </div>
      <div className="end">
        <div className="info">
          {pageIndex + 1} of {nbPages} pages
        </div>
        <div className="actions">
          <QtmButton color="primary" variant="ghost" onClick={onFirstPage}>
            <QtmIcon icon="first_page" />
          </QtmButton>
          <QtmButton color="primary" variant="ghost" onClick={onPreviousPage}>
            <QtmIcon icon="navigate_before" />
          </QtmButton>
          <QtmButton color="primary" variant="ghost" onClick={onNextPage}>
            <QtmIcon icon="navigate_next" />
          </QtmButton>
          <QtmButton color="primary" variant="ghost" onClick={onLastPage}>
            <QtmIcon icon="last_page" />
          </QtmButton>
        </div>
      </div>
    </div>
  );
};

export default DataTableFooter;
